import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import WhiteboardContainerController from './WhiteboardContainerController';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';

const ModalMessage: React.FC<{}> = () => {
  const controller = useController(WhiteboardContainerController);
  const { modalMessageTitle, modalMessageProgress } = controller.state;

  return (
    <aha-modal
      open={customElementBoolAttr(modalMessageTitle !== null)}
      size='small'
      restrict
      persistent
    >
      <aha-modal-header modal-title={modalMessageTitle}>
        <div slot='header-actions' />
      </aha-modal-header>
      <aha-modal-body>
        <div className='progress progress-striped active background-job-modal__bar'>
          <div className='bar' style={{ width: `${modalMessageProgress}%` }} />
        </div>
      </aha-modal-body>
    </aha-modal>
  );
};

export default ApplicationView(ModalMessage);
